<template>
    <body>
    <form @submit.prevent="createCode">
        <div class="imgcontainer">
            <img src="../assets/serpi_main.jpeg"  style="background-color: white" alt="Avatar" class="avatar">Client Profile
            <br>
            <span style="font-size: 8px">Next input data will generate a private key to be used when make appointment</span>
        </div>
        <div class="container">
            <label for="email"><b>E-mail</b></label>
            <input type="text" placeholder="Enter email" id="email" v-model="this.profile.email" required>
            <label for="fname"><b>First Name</b></label>
            <input type="text" placeholder="Enter First Name" id="fname" v-model="this.profile.fname" required>
            <label for="lname"><b>Last Name</b></label>
            <input type="text" placeholder="Enter Last Name" id="lname" v-model="this.profile.lname" required>
            <button v-if="!editProfile" type="submit" :disabled="offCode">Generate Key</button>
            <button v-else type="submit" :disabled="offCode">update Profile</button>
            <button type="button" class="cancelbtn" @click="goToHome">Cancel</button>
        </div>
    </form>
    <div style="font-size: 10px;text-align: center">
        <span style="color:yellow"><i class="fa fa-shield" aria-hidden="true"></i> Privacy Policy</span> <br>
        The User's personal data (E-mail, LastName, FirstName)
        <span style="font-weight: bold">are not </span> stored on the App Server.
    </div>
    </body>
</template>
<script>
    import {generateHID, saveClientProfileToLocal,getClientProfile} from "../hid.js"
    import {getBaseURL} from "../url_endpoints.js"
    import {ulip_post} from "../https_requests.js"
    export default {
        name:'Profile',
        data() {
            return {
                profile : {
                    fname:'',
                    lname:'',
                    email:'',
                    hid:null
                },
                editProfile:false,
            }
        },
        mounted() {
            let localprofile = getClientProfile()
            if( localprofile != null) {
                this.profile = localprofile
            }
            this.editProfile = localprofile!== null ? true: false
        },
        computed: {
            offCode() {
                if(!this.profile.fname || !this.profile.lname || !this.profile.email) return true
                if( (this.profile.fname.length > 0) && (this.profile.lname.length >0) &&(this.profile.email.length >0)){
                    return false
                } else {
                    return true
                }
            }
        },
        methods: {
            createCode() {
                if(this.editProfile) {
                    saveClientProfileToLocal(this.profile)
                    alert('Your Profile was updated!')
                    this.$router.push('/client')
                    return
                }
                const hid1 = generateHID(this.profile.email + this.profile.fname + this.profile.lname)
                const d = new Date()
                const hid2 = generateHID(hid1 + d)
                // update profile object
                this.profile.hid = hid2
                // prepare for FETCH
                let baseURL = getBaseURL()
                //create resource on the back-end  -> save HID for the new Customer
                let customer = {
                    hid:hid2,
                }
                ulip_post(baseURL,'/customers',customer).then(() => {
                    //console.log('New customer saved: ' , rsp['hid'])
                    // go to clients list
                    alert('Your Profile was registered!...')
                    saveClientProfileToLocal(this.profile)
                    this.$router.push('/client')
                }).catch(err => {
                    //console.log('Error when post new customer: ', err.message)
                    alert(err.message+ '\nBackend Server could be down! Try again later')
                })
            },
            goToHome() {
                this.$router.push('/client')
            }
        }
    }
</script>
<style lang="scss" scoped>
    body {
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        background-color: black;
        color: white;
        height:100vh;
    }
    /*
    form {
        border: 3px solid #f1f1f1;
    }*/

    input[type=text], input[type=password] {
        width: 100%;
        padding: 10px 20px;
        margin: 5px 0;
        display: inline-block;
        border: 1px solid #ccc;
        box-sizing: border-box;

    }

    button {
        background-color: #4CAF50;
        color: white;
        padding: 14px 20px;
        margin: 8px 0;
        border: none;
        cursor: pointer;
        width: 100%;
    }

    button:hover {
        opacity: 0.8;
    }
    button:disabled {
        background-color: darkgray;
    }

    .cancelbtn {
        padding: 10px 18px;
        background-color: #f44336;
    }

    .imgcontainer {
        text-align: center;
        margin: 24px 0 12px 0;
    }

    img.avatar {
        width: 25%;
        border-radius: 70%;
    }

    .container {
        padding: 16px 30%;
    }

    span.psw {
        float: right;
        padding-top: 16px;
    }

    /* Change styles for span and cancel button on extra small screens */
    @media screen and (max-width: 414px) {
        span.psw {
            display: block;
            float: none;
        }
        .cancelbtn {
            width: 100%;
        }
        button {
            width: 100%;
        }
        .container {
            padding: 5px;
        }
    }
    a:visited {
        color: lightsalmon;
    }
</style>